export default {
	home: 'Accueil',
	contact: 'Contact',
	aboutUs: 'À propos de nous',
	logout: 'Se déconnecter',
	login: "S'identifier",
	register: 'Inscrivez-vous ici',
	search: 'Chercher',
	login_fa: 'Se connecter avec Facebook',
	login_go: 'Connectez-vous avec Google',
	sign_in_man: 'Connectez-vous manuellement',
	username: "Nom d'utilisateur",
	password: 'Mot de passe',
	btn_register: "S'inscrire maintenant",
	btn_lost_pass: 'Mot de passe oublié?',
	text_remenber: 'Souviens-toi de moi',
	check_in: 'Enregistrement',
	itfa_abr: 'INDEPENDENT TELEFOOTBALL ASSOCIATION',
	select_platform: 'Sélectionnez une plateforme',
	about_us:
		'<p>In order to get as close to <strong>our way</strong> to run a competition as real as possible in FIFA would like to highlight some details about what your experience in this game.</p><p>Currently we have about 800+ players in our Pro Clubs & Groups 1v1 is soon to be held, where many are involved in one or other of the powers that are exclusive to PS4 due to various reasons.</p><p>Esta página web, esta echa para todos ustedes donde habra torneos sobre FIFA 16.</p><p>– 1 VS 1 where you can demonstrate your ability.</p><p>– PRO CLUBS it is a mode of FIFA 16 online game where you can create a Virtual Pro player and play your own position in the field with your fellow realistically as you can live football online. The more games you play and unlock more feats, Virtual Pro unlock your best attributes and appearance options. Play casual games or join a club or create your own to get points with your own club.</p><p>You can also interact with us, MarDar photos from your club oh video, contact us, ask questions and send suggestions and comments on our way as we have the web and Administration page, ensuring to serve them and respond as soon as possible with a problem that have.</p><p><strong>A cordial greeting.</strong></p><p>We hope to meet your expectations with quality and satisfaction quickly because it is our true FIFA16 philosophy of work.</p>',
	text_contact:
		'<p>Thanks for your visit.</p><p>If you have any suggestions, complaints or comments please write, we will be happy to answer.</p>',
	subject: 'Matière',
	email: 'E-mail',
	name: 'Nom',
	message: 'Message',
	messages: 'Messages',
	required: 'Obligatoire',
	submit: 'Soumettre',
	return: 'Revenir',
	pleaseWait: "S'il vous plaît, attendez...",
	registerTitle: "Enregistrement de l'utilisateur",
	repeatPassword: 'Répétez votre mot de passe',
	country: 'Pays',
	position: 'Position',
	console: 'Console',
	motto: 'Devise',
	selectOption: 'Sélectionnez une option',
	allRightsReserved: 'All rights reserved',
	profile: 'Profil',
	myProfile: 'mon profil',
	friends: 'Copains',
	edit: 'Éditer',
	editUser: 'Modifier mes informations',
	language: 'Langue',
	save: 'sauvegarder',
	changePassword: 'Changer le mot de passe',
	currentPassword: 'Mot de passe actuel',
	newPassword: 'Nouveau mot de passe',
	repeatNewPassword: 'Répété le nouveau mot de passe',
	options: 'Les options',
	createAdmins: 'Create administrators',
	sliderPrimary: 'Slider primary',
	changeGt: 'Change gamertag',
	toPremium: 'Switch to premium',
	updatedData: 'Update data',
	tutorialCreate: 'Create tutorial',
	bets: 'Pari',
	textChangeImgSlider:
		'<li>The image should have no more weight than 2MB.</li><li>Minimum resolution 1366 x 598 pixels.</li><li>The only permitted extension is JPG.</li>',
	findImage: 'Image search',
	details: 'Details',
	updatedInfo: 'Informations mises à jour.',
	create: 'Créer',
	title: 'Titre',
	delete: 'Supprimer',
	error404: "La ressource n'existe pas.",
	enterUserId: "Entrez l'ID d'un utilisateur",
	cancel: 'Annuler',
	confirmTitleDelete: 'Confirmation de la suppression',
	confirmTextDelete: "Vous êtes sûr de supprimer l'élément sélectionné ?",
	editInfoUser: 'Modifier les informations des utilisateurs',
	resetPassword: 'réinitialisez votre mot de passe',
	enterYourEmail: 'Entrer votre Email',
	myNews: 'Mes nouvelles',
	image: 'Image',
	published: 'Publié',
	modified: 'Modifié',
	comments: 'Bemerkungen',
	date: 'Date',
	time: 'Temps',
	createdAgo: 'Créé il y a',
	content: 'Contenu',
	cover: 'Page de Couverture',
	show: 'Spectacle',
	enterIdOrUsername: "Entrez un ID de joueur ou un nom d'utilisateur",
	month: 'mois | mois',
	year: 'année | ans',
	selectPlatform: 'Sélectionnez une plateforme',
	langEs: 'Spanish',
	langEn: 'English',
	langPt: 'Portuguese',
	description: 'La description',
	videoCode: 'Code vidéo',
	order: 'Commande',
	tournaments: 'Tournois',
	tournament: 'Tournoi',
	favorites: 'Favoris',
	online: 'En ligne',
	notices: 'Nouvelles',
	readMore: 'Read more',
	seeAllNews: 'Voir toutes les actualités',
	rankingPlayers: 'Classement des joueurs',
	rankingTeams: 'Classement des équipements',
	lastMatches: 'Derniers matchs',
	round: 'rond | Les manches',
	theBest: 'Le meilleur',
	signings: 'Signatures',
	rules: 'Règles',
	divisions: 'Divisions',
	division: 'Division',
	teams: 'Équipes',
	team: 'Équipe',
	transfers: 'Transferts',
	assistances: 'Assistances',
	scorer: 'Buteur | Buteurs',
	transferClose: "{time} gauche jusqu'à la fermeture",
	transferOpen: '{time} gauche pour ouvrir',
	goal: 'objectif | buts',
	assistance: 'aider | aide',
	goalkeeper: 'Gardien | Gardiens',
	bestPlayer: 'Meilleur joueur',
	point: 'point | points',
	bestDefense: 'La meilleure défense',
	bestOffensive: 'La meilleure offensive',
	goalFavor: 'but en faveur | buts en faveur',
	goalAgainst: 'but contre | buts contre',
	player: 'Joueur',
	players: 'Joueurs',
	ranking: 'Classement',
	status: 'Statut',
	price: 'Prix',
	purchasedBy: 'Acheté par',
	availableMoney: 'Argent disponible',
	free: 'gratuit',
	signing: 'Signé',
	playedGames: 'Matchs joués',
	yellowCard: 'carton jaune | cartons jaunes',
	redCard: 'carton rouge | cartons rouges',
	joinTheMarket: 'Rejoignez le marché',
	joinTheMarketConfirm:
		'Êtes-vous sûr de vouloir rejoindre la liste des joueurs gratuits du tournoi?',
	yes: 'Oui',
	not: 'ne pas',
	notice: 'Remarquer',
	contract: 'Contrat',
	sellPlayers: 'Vendre des joueurs',
	pendingRounds: 'Tours en attente',
	sellerPlayerConfirm:
		'Sind Sie sicher, dass Sie an den ausgewählten Spieler verkaufen möchten?',
	table: 'Table',
	card: 'carte | cartes',
	teamWeek: 'Équipe de la semaine',
	nextMatches: 'Prochains matchs',
	results: 'risultati',
	privateMsgFor: 'Message privé pour {user}',
	pj: 'MJ',
	pg: 'MG',
	pe: 'N',
	pp: 'MP',
	gf: 'BP',
	gc: 'BC',
	dg: 'DB',
	seeDT: 'Voir manager',
	matches: 'Allumettes',
	quantity: 'Quantité',
	training: 'Formation',
	defense: 'Défenses',
	midfielders: 'Milieux de Terrain',
	front: 'De face',
	award: 'prix | prix',
	champion: 'CHAMPION',
	stats: 'Statistiques',
	type: 'Type',
	record: 'Record',
	changeImage: "Changer l'image",
	addTeam: 'Ajouter une équipe',
	textFindNotice: 'Saisissez une ou plusieurs lettres, puis appuyez sur ENTREE',
	sendInvitation: 'Envoyer une invitation',
	createTournament: 'Créer un tournoi',
	editTournament: 'Modifier le tournoi',
	mode: 'mode',
	category: 'catégorie | catégories',
	hideTournament: 'Masquer le tournoi?',
	deleteAllPlayersOfTeam:
		"Voulez-vous vraiment supprimer tous les joueurs de l'équipe sélectionnée?",
	handOutMoney: "Distribuer de l'argent",
	add: 'Ajouter',
	remove: 'Retirer',
	transfersClosed: 'Transferts - est fermé',
	transfersOpened: 'Transfert - est ouvert',
	transfersClosedMsg:
		"Le transfert est clos, les joueurs invités pourront entrer dans l'équipe.",
	transfersOpenedMsg:
		"Le transfert est ouvert, les joueurs qui ont été invités et qui n'ont pas accepté ne peuvent pas entrer dans l'équipe avant la prochaine signature.",
	open: 'Ouvert',
	close: 'Fermer',
	customButtons: 'Boutons personnalisés',
	label: 'Étiquette',
	showIn: 'Montre',
	selfLink: 'Dans la même page',
	blankLink: 'Sur une autre page',
	views: 'Vues',
	administrator: 'administrateur | administrateurs',
	enterPlayerNick: "Entrez le surnom d'un joueur",
	user: 'utilisateur',
	roundsFinalPhase: 'ROUNDS domicile / extérieur',
	allFinalPhase: 'TOUT CONTRE TOUS / 1jeu',
	manualDirectDisposal: 'ÉLIMINATION DIRECTE MANUELLE',
	autoDirectDisposal: 'ÉLIMINATION DIRECTE AUTOMATIQUE',
	numberTeamsDown: "Nombre d'équipes en baisse",
	numberTeamsPassLiguilla: "Nombre d'équipes passant la liguille de l'aile",
	season: 'saison | saisons',
	deliverCup: 'Livrer la tasse',
	removeCup: 'RETIRER LA COUPE',
	toStart: 'COMMENCER',
	programming: 'PROGRAMMATION',
	inProgress: 'EN COURS',
	finished: 'FINI',
	played: 'JOUÉ',
	notPresented: 'GAGNÉ PAR DÉFAUT',
	changeDatesRounds: 'Modifier les dates des tours',
	addPlayTime: 'Ajouter du temps de lecture',
	selectDays: 'Sélectionnez un ou plusieurs jours de la semaine',
	monday: 'Lundi',
	tuesday: 'Mardi',
	wednesday: 'Mercredi',
	thursday: 'Jeudi',
	friday: 'Vendredi',
	saturday: 'samedi',
	sunday: 'dimanche',
	schedule: 'Calendrier des matchs',
	transferDate: 'Date de transfert',
	dateNextSigning: 'Date de la prochaine signature',
	endDate: 'Date limite',
	choose: 'Choisir',
	alternate: 'Alterner',
	showFixture: 'Montrez le montage',
	msgCreateFixture:
		"Après avoir créé l'appareil, vous ne pouvez plus ajouter plus d'équipement au tournoi. Bien sûr de continuer?",
	createFixture: 'Créer un appareil',
	btnIfContinue: 'Si je veux continuer',
	createLiguilla: 'Créer une liguille',
	thirdPlace: 'Troisième place',
	myClub: 'Mon club',
	myTeams: 'Mes équipes',
	myGames: 'Mes jeux',
	management: 'La gestion',
	tshirts: 'T-shirts',
	notification: 'notification | notifications',
	from: 'De',
	detailsNotification: 'Notification des détails',
	invitation: 'invitation | invitations',
	accept: "J'accepte",
	deny: 'Nier',
	invitationAccepted: 'Invitation acceptée.',
	invitationRejected: 'Invitation rejetée.',
	transferPlayer: 'Transférer le joueur',
	freePlayerPremium: 'Voulez-vous libérer le lecteur sélectionné?',
	trainingShow: 'Formation pour montrer',
	teamFormation: "Formation d'équipe",
	myFormation: 'Ma formation',
	invitePlayers: 'Joueurs invités',
	myFavouriteTeams: 'Mes équipes préférées',
	myFavouriteTournaments: 'Mes tournois préférés',
	visitor: 'Visiteur',
	watchMatch: 'Regarder le match',
	editVideos: 'Modifier des vidéos',
	addPictures: 'Ajouter des photos',
	toUpdate: 'Mettre à jour',
	editMatch: 'Modifier les résultats du match',
	participated: 'Joindre',
	none: 'Aucun',
	changeResultMatch: "Modifier les résultats d'un match",
	changeResults: 'Changer les résultats',
	changeStatistics: 'Changer les statistiques',
	enabledStatistics: "Activer l'édition des statistiques",
	all: 'Tout',
	coins: 'Pièces de monnaie',
	duration: 'Durée',
	toBuy: 'Acheter',
	relatedProducts: 'Produits connexes',
	purchasedProducts: 'Produits achetés',
	boughtOn: 'Acheté le',
	beatOn: 'Continuez',
	use: 'UTILISATION',
	addCategory: 'Ajouter une catégorie',
	bgTournaments: 'Image de fond pour les tournois',
	bgDivisions: 'Image de fond pour les divisions',
	bgTeams: 'Image de fond pour les équipes',
	bgPlayers: 'Image de fond pour les joueurs',
	editCategory: 'Modifier la catégorie',
	addSubcategory: 'Ajouter une sous-catégorie',
	editSubcategory: 'Modifier la sous-catégorie',
	createProduct: 'Créer un produit',
	visible: 'Visible',
	editProduct: 'Modifier le produit',
	cardNumber: 'Numéro de carte',
	expirationDate: "Date d'expiration",
	matchBetting: 'Paris sur les matchs',
	matchWin: 'Victoire du match',
	bet: 'Pari',
	gain: 'Gain',
	matchesBet: 'Matchs avec pari',
	entry: 'Entrée',
	betMsgEntry:
		'Il déduira (<strong>{coin}</strong>) de vos pièces pour jouer à ce jeu',
	confirmResults: 'Confirmer les résultats',
	whatLokingFor: '¿Que cherchez-vous?',
	textFind: 'Saisissez 3 lettres ou caractères',
	searchResults: 'Résultats de votre recherche',
	seeCard: 'Voir la carte',
	only15Letters: 'Seulement 15 caractères.',
	rename: 'Renommer',
	sendLinkResetPassword: 'Changer le mot de passe par e-mail',
	end: 'FIN',
	deliverPrizes: 'Remettre des prix',
	confirm: 'Confirmer',
	awardsConfirmText:
		'Êtes-vous sûr de continuer? <br />Cette option ne peut pas être annulée.',
	donateTitle: 'Nous apprécions le soutien fourni',
	donateThanks: 'Merci pour votre aide.',
	donateText:
		"<p>L'organisation ITFA remercie toutes les personnes qui apprécient d'une manière ou d'une autre le travail acharné de l'administration de cette page dans laquelle de multiples tournois de grande renommée et de haute compétitivité sont organisés.</p><p>À tous ces sponsors qui effectuent anonymement.</p><p>Nous sommes reconnaissants pour la contribution, car ils nous motivent à poursuivre ce grand projet en améliorant la page et en la maintenant.</p>",
	donate: 'faire un don | des dons',
	amountToDonate: 'Montant à donner',
	premiumForMonth: 'Prix valable 1 mois | Prix valable 1 {month} mois',
	priceForMonth: '1 mois | {month} mois',
	movements: 'Mouvements',
	transferIn: '{player} est maintenant un {team} joueur',
	transferOut: '{player} a quitté le club {team}',
	changeCup: 'Changer de tasse',
	banned: 'Banni',
	reason: 'Raison',
	bannedStart: 'Début',
	bannedEnd: 'Baignoire',
	countries: 'Les pays',
	change: 'Changer',
}
